// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1IdO-","title":"ClientCherryInfo_title__3KJ7f","itemText":"ClientCherryInfo_itemText__AeCq_"};